import React, { useState, useEffect, useMemo } from 'react';
import { Alert, TouchableOpacity, View } from 'react-native'

import api from "@/utils/api"
import tw from '@/styles/tailwind';
import Text from '@/components/Text';
import Icon from '@/components/IcomoonIcon';
// import BottomSheetModal from '@/components/BottomSheetModal';
import { useForm } from 'react-hook-form';
import useFormSubmit from '@/hooks/useFormSubmit';
import Input from '@/components/Forms/Input';
import Button from '@/components/Forms/Button';
import BottomSheetModal from '@/components/BottomSheet';
import LabelSwitch from '@/components/Forms/LabelSwitch';
import IconButton from '@/components/IconButton';



export default function PaymentRequestApprovalRejectBottomSheet({
  visible,
  onRequestClose,
  onPaymentRequestRejected,
  paymentRequestId,
}) {
  const { control, reset, handleSubmit, setValue, formState: { isDirty }, watch } = useForm();
  // const unitId = watch('unit_id')

 

  // useEffect(() => {
  //   reset({
  //     name: tag.name,
  //     active: tag.active,
  //     unit_id: initialUnitId,
  //   })
  // }, []);

  const { submitForm, isSubmitting } = useFormSubmit({
    onSuccess: onPaymentRequestRejected,
    onError: (error) => {
      console.log(error)
    },
    successToastMessage: `Pago rechazado exitosamente`,
    endpoint: `/vinte/payment-requests/${paymentRequestId}/approval-review`,
  })


  const _submitForm = (data) => {
    const _data = {
      ...data,
      veredict: 'rejected',
    }

    submitForm(_data)
  }



  const snapPoints = useMemo(() => {
    return [200, 400]
  }, []);


  return (
    <BottomSheetModal
      snapPoints={snapPoints}
      visible={visible}
      onRequestClose={onRequestClose}
      showCloseButton={true}
      height={450}
    >
      <View style={tw`px-5 pt-6`}>
        <View style={tw``}>
          <Text style={tw`text-gray-500 font-500 mb-3`}>Motivo del rechazo</Text>

          <Input
            control={control}
            name='comments'
            multiline
            numberOfLines={4}
            placeholder=''
            style={{ input: ``, subcontainer: `rounded-xl` }}
            rules={{ required: true }}
          />
        </View>

        {/* <Button
          label={isSubmitting ? 'Guardando' : 'Rechazar solicitud'}
          disabled={isSubmitting}//  || !isDirty
          onPress={handleSubmit(_submitForm)}
        /> */}

        <IconButton
          style={`flex-1 rounded-xl py-3`}
          onPress={handleSubmit(_submitForm)}
          title={'Rechazar Pago'}
          color={'red-500'}
          icon='cancel'
          disabled={isSubmitting}
        />
      </View>
    </BottomSheetModal>
  )
}